import { createSignal } from '@verclam/pulsar';

type DocumentSettingsScreenContext = {
	readonly stageIndex: number;
	readonly stepIndex: number;
};

/** Position of the document whose settings screen replaces the group editor; null shows the editor. */
const documentSettingsScreenSignal = createSignal<DocumentSettingsScreenContext | null>(null);

export const openDocumentSettingsScreen = (stageIndex: number, stepIndex: number): void => {
	documentSettingsScreenSignal.value = { stageIndex, stepIndex };
};

export const closeDocumentSettingsScreen = (): void => {
	documentSettingsScreenSignal.value = null;
};

export default documentSettingsScreenSignal;
